/**
 * AI-generated code, moderated by lzygmanski
 */
import dayjs from 'dayjs';
import {useTranslation} from 'react-i18next';

import {Typography} from '@/components/ui/typography';
import {TIME_FORMATS} from '@/utils/timeFormats';

export type AmbulancePrintHeaderProps = {
  reportCreatedAt: string;
};

const AmbulancePrintHeader = ({reportCreatedAt}: AmbulancePrintHeaderProps) => {
  const {t} = useTranslation();

  return (
    <div className="border-b border-border pb-4">
      <Typography variant="h1" asChild className="text-2xl font-bold">
        <h1>{t('Ambulance report')}</h1>
      </Typography>
      <Typography className="text-sm text-muted-foreground">
        {t('Generated at')}:{' '}
        {dayjs(reportCreatedAt).format(TIME_FORMATS.dateTime)}
      </Typography>
    </div>
  );
};

export default AmbulancePrintHeader;
